//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
    components: {
        Paywall: () => import('~/components/payment/module.vue')
    },
    head() {
        return {
            title: 'Betalen | ' + this.$seo.direct.title + ' | ' + this.$config.appTitle,
            meta: [
                { hid: 'robots', name: 'robots', content: 'noindex' },
                { hid: 'title', name: 'title', content: 'Betalen | ' + this.$seo.direct.title + ' | ' + this.$config.appTitle },
                { hid: 'og:title', name: 'og:title', content: 'Betalen | ' + this.$seo.direct.title + ' | ' + this.$config.appTitle },
                { hid: 'og:url', name: 'og:url', content: this.$config.feUrl + this.$seo.direct.slug + '/betalen' },
                { hid: 'og:description', name: 'og:description', content: 'Start op deze pagina jouw ' + this.$config.appTitle + ' ' +  this.$seo.direct.title + ' abonnement' },
                { hid: 'description', name: 'description', content: 'Start op deze pagina jouw ' + this.$config.appTitle + ' ' +  this.$seo.direct.title + ' abonnement' },
                { hid: 'keywords', name: 'keywords', content: this.$seo.direct.keyowrds + ', betalen' },
            ]
        }
    },
    mounted() {
        if (this.$root.isMobile && this.$auth.LoggedIn) {
            this.$store.commit('paywallStore/setView', 'active'); 
            this.$store.commit('subscriptionsStore/setPaywallToSubscription', 'direct');
            this.$store.commit('paywallStore/setStep', 2);
        }
    },
    methods: { 
        start() {
            if (this.$auth.loggedIn) {
                this.$store.commit('paywallStore/setView', 'active'); 
                this.$store.commit('subscriptionsStore/setPaywallToSubscription', 'direct');
                this.$store.commit('paywallStore/setStep', 2);
                return;
            } else {
                this.$store.commit('modalStore/setModal', 'account');
                return;
            }
        }
    }
}
